/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CondizioneDTO } from './condizione-dto';


export interface RegolaDTO { 
    id?: string;
    ordine?: number;
    contributo?: number;
    contributo_multifiglio?: number;
    condizioni?: Array<CondizioneDTO>;
}

